import {AlertBanner} from '@resurs-internal/mui';
import React from 'react';
import {useBanner} from '../../hooks';

export const BannerView = () => {
  const banner = useBanner();
  if (!banner.show) return null;

  const message = banner.query.data;
  return (
    <AlertBanner
      severity={message?.variant}
      title={message?.title}
      subtitle={message?.text}
      onClose={banner.dismiss}
      sx={{borderRadius: 0}}
    />
  );
};
